module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": {
        path: '/record-completedCourse-detail',
        query: {
          id: _vm.obj.id
        }
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "des",
    domProps: {
      "textContent": _vm._s(_vm.obj.courseId)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "des1",
    domProps: {
      "textContent": _vm._s(_vm.obj.createTime + '>')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cb0fc59"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VCoureseShowCell.vue
// module id = 783
// module chunks = 1